import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { FormatCurrencyPipe } from './format-currency.pipe';

@NgModule({
  declarations: [FormatCurrencyPipe],
  imports: [CommonModule],
  exports: [FormatCurrencyPipe],
  providers: [CurrencyPipe],
})
export class FormatCurrencyPipeModule {}
